import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { SearchBar } from 'crm/_components';
import { staticStyles } from './style';

const ManagersActionsTab = ({ location, history }) => {
  const query = useMemo(() => ({ ...queryString.parse(location.search) }), [location.search]);

  const handleSearchChange = searchValue => {
    history.replace({
      ...location,
      search: queryString.stringify({
        ...query,
        search: searchValue,
      }),
    });
  };

  return (
    <div className="ManagersActionsTab">
      <div className="ManagersActionsTab__Top">
        <div className="ManagersActionsTab__TopLeft">
          <SearchBar onChange={handleSearchChange} />
        </div>
      </div>
      <style jsx>{staticStyles}</style>
    </div>
  );
};

ManagersActionsTab.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(ManagersActionsTab);
